import React from 'react';
import './Cali.css'; 

const Inirida = () => {
  return (
   <div>
    <div className='Espacio-titulo'>
    <h1><a className='Titulo' href="/aip/SKPD.pdf" target="_blank" rel="noreferrer">Aeropuerto Cesar Gaviria</a></h1>
    </div>

    <div className='containeraeropuertos'>
      
      <div className='subcontaineraeropuertos'>
        <h1>SID</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 18</th>                      
          </tr>  
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2A.pdf" target="_blank" rel="noreferrer">PANI2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2A.pdf" target="_blank" rel="noreferrer">UMBE2A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2A.pdf" target="_blank" rel="noreferrer">RAXI1A</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2A.pdf" target="_blank" rel="noreferrer">REDE1A</a></th>
          </tr>

               
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos1'>
              <th className="pista">PISTA 36</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2B.pdf" target="_blank" rel="noreferrer">PANI2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2B.pdf" target="_blank" rel="noreferrer">UMBE2B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2B.pdf" target="_blank" rel="noreferrer">RAXI1B</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2B.pdf" target="_blank" rel="noreferrer">REDE1B</a></th>
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>STAR</h1>
        <div className='container-tablas'>
          <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 18</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2C.pdf" target="_blank" rel="noreferrer">PANI2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2C.pdf" target="_blank" rel="noreferrer">UMBE2C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2C.pdf" target="_blank" rel="noreferrer">RAXI1C</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/PANI2C.pdf" target="_blank" rel="noreferrer">REDE1C</a></th>
          </tr>

          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos2'>
              <th className="pista">PISTA 36</th>                      
          </tr>
          
          </table>
        </div> 
      </div>

      <div className='subcontaineraeropuertos'>
        <h1>IAC</h1>
        <div className='container-tablas'>
           <table className='tabla-aeropuertos1'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 18</th>                      
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/VOR18.pdf" target="_blank" rel="noreferrer">VOR</a></th>
          </tr>
          <tr>
            <th className='Procedimientos'><a href="/regionales/SKPD/RNP18.pdf" target="_blank" rel="noreferrer">RNP</a></th>
          </tr>
          </table>
          <table className='tabla-aeropuertos2'>
          <tr className='divisoraeropuertos3'>
              <th className="pista">PISTA 36</th>                      
          </tr> 
          
          </table>
        </div>
      </div>

    </div>

  </div>
  );
};
export default Inirida;